import { FETCH_LOGOTYPES } from './types';

export const fetchLogotypes = () => dispatch => {
    fetch('https://sinomost.kz/API/home/logotypes/')
    .then(res => res.json())
    .then(logotypes => dispatch({
        type: FETCH_LOGOTYPES,
        payload: logotypes
    }));
};